module.exports = __webpack_public_path__ + "img/pro2.jpg";